// extracted by mini-css-extract-plugin
export default {"burger_item":"item-burger_burger_item__byNIW","burger_price":"item-burger_burger_price__sdw5E"};